<template>
  <div class="expend-settings-settings">
    <a-form-model class="app-form" ref="form" :model="form" :rules="rules" :labelCol="$formLabelCol" :wrapperCol="$formWrapperCol">
      <template v-if="!id">
        <a-form-model-item label="缴费范围" prop="house">
          <div>
            <a-button type="primary" @click="showModal" :disabled="!!house">选择</a-button>
          </div>
          <div>
            <a-tag class="large" closable @close.prevent="delHouse(index)" v-for="(value, index) in form.house" :key="index">{{value.full_name}}</a-tag>
          </div>
        </a-form-model-item>
        <a-form-model-item label="费项科目" prop="fee">
          <a-select v-model="form.fee" placeholder="请选择费项科目">
            <a-select-option :value="value.id" v-for="value in feeOptions" :key="value.id">{{value.name}}</a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="计费开始时间" prop="startTime">
          <a-date-picker v-model="form.startTime" placeholder="请选择计费开始时间" show-time valueFormat="YYYY-MM-DD HH:mm:ss"></a-date-picker>
        </a-form-model-item>
      </template>
      <a-form-model-item label="计费结束时间" prop="endTime">
        <a-date-picker v-model="form.endTime" placeholder="请选择计费结束时间，不选择表示不限制时间，长期有效" show-time valueFormat="YYYY-MM-DD HH:mm:ss"></a-date-picker>
      </a-form-model-item>
    </a-form-model>
    <a-modal :title="modal.title" v-model="modal.show" @ok="confirmModal" destroy-on-close width="60%" centered>
      <tree-select v-model="modal.house" :data="tree.data" :params="tree.params" :load-data="$houseTreeData" multiple @load="loadTreeSelectNode">
        <template slot-scope="{row}">
          <a-row type="flex">
            <a-col flex="1">{{row[tree.params.title]}}</a-col>
            <a-col>
              <dy-icon type="icon-batch" @click.stop="batchSelectHome(row)"></dy-icon>
            </a-col>
          </a-row>
        </template>
      </tree-select>
    </a-modal>
    <a-modal :title="batchModal.title" v-model="batchModal.show" @ok="confirmBatchModal" destroy-on-close width="60%" centered>
      <batch-select-house :init-data="batchModal.data" v-model="batchModal.house"></batch-select-house>
    </a-modal>
  </div>
</template>

<script>
  import ExpendService from '@/io/expend.js';

  export default {
    name: 'ExpendSettingsSettings',
    props: {
      id: {
        type: Number,
        default() {
          return null
        }
      },
      house: {
        type: Object,
        default: null
      }
    },
    data() {
      return {
        form: {
          house: [],
          fee: [],
          startTime: null,
          endTime: null
        },
        rules: {
          house: [
            {
              required: true,
              message: '请选择缴费范围'
            }
          ],
          fee: [
            {
              required: true,
              message: '请选择费项科目'
            }
          ],
          startTime: [
            {
              required: true,
              message: '请选择计费开始时间'
            }
          ]
        },
        feeOptions: [],
        tree: {
          data: [],
          params: {
            children: 'children',
            title: 'name',
            key: '_id'
          }
        },
        modal: {
          title: '选择房源',
          show: false,
          house: []
        },
        batchModal: {
          title: '批量选择房间',
          show: false,
          house: [],
          data: []
        }
      }
    },
    watch: {
      id: {
        handler(newValue, oldValue) {
          this.$houseTreeData([], [this.isPlatformRole ? 0 : 1, 4]).then(res => {
            this.tree.data = res;
            this.initPage();
          });
        },
        immediate: true
      },
      'form.house': {
        handler(newValue, oldValue) {
          if (newValue.length) {
            let ids = newValue.map(val => val.communityId || val.community_id || val.id);
            this.initFeeOptions(ids.filter((value, index) => ids.indexOf(value) === index));
          }
        },
        immediate: true
      },
      house: {
        handler(newValue, oldValue) {
          if (newValue) {
            this.form.house = [newValue];
          }
        },
        immediate: true
      }
    },
    methods: {
      initFeeOptions(ids) {
        return ExpendService.list(ids).then(res => {
          this.feeOptions = res;
        }).catch(err => {});
      },
      loadTreeSelectNode(data) {
        if (data.level === 2) {
          this.$set(data, 'scopedSlots', {
            title: 'title'
          });
        }
      },
      confirmBatchModal() {
        let house = [];
        this.batchModal.house.forEach(val => {
          if (this.modal.house.map(m => m[this.tree.params.key]).indexOf(val[this.tree.params.key]) === -1) {
            house.push(val);
          }
        });
        this.modal.house = this.modal.house.concat(house);
        this.batchModal.show = false;
        this.batchModal.house = [];
        this.batchModal.data = [];
      },
      batchSelectHome(data) {
        this.batchModal.data = data.children.map(val => val.children);
        this.batchModal.show = true;
      },
      initPage() {
        if (this.id) {
          ExpendService.settingsInfo(this.id).then(res => {
            this.form.endTime = res.end_date;
          }).catch(err => {});
        }
      },
      showModal() {
        this.modal.show = true;
        this.modal.house = this.$createNewVariable(this.form.house);
      },
      confirmModal() {
        this.modal.show = false;
        this.form.house = this.$createNewVariable(this.modal.house);
      },
      delHouse(index) {
        this.form.house.splice(index, 1);
      },
      submit(callback = () => {}) {
        this.$beforeFormSubmit(this.$refs.form, () => {
          if (this.id) {
            ExpendService.editSettings(
              this.id,
              this.form.endTime
            ).then(res => {
              this.$afterFormSubmit('编辑成功', () => {
                callback();
              });
            }).catch(err => {});
          } else {
            ExpendService.settings(
              this.form.house.filter(val => !val.level).map(val => val.id),
              this.form.house.filter(val => val.level === 1).map(val => val.id),
              this.form.house.filter(val => val.level === 2).map(val => val.id),
              this.form.house.filter(val => val.level === 3).map(val => val.id),
              this.form.house.filter(val => val.level === 4).map(val => val.id),
              this.form.fee,
              this.form.startTime,
              this.form.endTime
            ).then(res => {
              this.$afterFormSubmit('创建成功', () => {
                callback();
              });
            }).catch(err => {});
          }
        });
      }
    },
  }
</script>

<style lang="less" scoped>
  
</style>